import {CdAimEvaluationOrderOption} from '../../../interfaces/care/cd-care-plan/cd-aim-evaluation-order-option';

export class CdAimEvaluationOrderOptionFactory {

  /**
   *
   * @param cdAimEvaluationOrderOption
   */
  public static fromObject(cdAimEvaluationOrderOption: any): CdAimEvaluationOrderOption {
    return new class implements CdAimEvaluationOrderOption {
      id: number = cdAimEvaluationOrderOption.id;
      isActive: boolean = cdAimEvaluationOrderOption.is_active;
      name: string = cdAimEvaluationOrderOption.name;
      sort: number = cdAimEvaluationOrderOption.sort;
      shortName: string = cdAimEvaluationOrderOption.sort_name;
      withOwnOrder: boolean = cdAimEvaluationOrderOption.with_own_order;
    };
  }

  /**
   *
   * @param cdAimEvaluationOrderOptions
   */
  public static fromArray(cdAimEvaluationOrderOptions: any[]): CdAimEvaluationOrderOption[] {
    return cdAimEvaluationOrderOptions.map(
      _cdAimEvaluationOrderOption => CdAimEvaluationOrderOptionFactory.fromObject(_cdAimEvaluationOrderOption)
    );
  }

}
